var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "build-tools/npm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build-tools/npm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    stroke: "#5B0403",
    strokeWidth: 2,
    fill: "#CB3837",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Npm-logo",
    transform: "translate(10.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L50,0 L50,16.6666667 L25,16.6666667 L25,19.4444444 L13.8888889,19.4444444 L13.8888889,16.6666667 L0,16.6666667 L0,0 Z M2.77777778,13.8888889 L8.33333333,13.8888889 L8.33333333,5.55555556 L11.1111111,5.55555556 L11.1111111,13.8888889 L13.8888889,13.8888889 L13.8888889,2.77777778 L2.77777778,2.77777778 L2.77777778,13.8888889 Z M16.6666667,2.77777778 L16.6666667,16.6666667 L22.2222222,16.6666667 L22.2222222,13.8888889 L27.7777778,13.8888889 L27.7777778,2.77777778 L16.6666667,2.77777778 Z M22.2222222,5.55555556 L25,5.55555556 L25,11.1111111 L22.2222222,11.1111111 L22.2222222,5.55555556 Z M30.5555556,2.77777778 L30.5555556,13.8888889 L36.1111111,13.8888889 L36.1111111,5.55555556 L38.8888889,5.55555556 L38.8888889,13.8888889 L41.6666667,13.8888889 L41.6666667,5.55555556 L44.4444444,5.55555556 L44.4444444,13.8888889 L47.2222222,13.8888889 L47.2222222,2.77777778 L30.5555556,2.77777778 Z",
    id: "Shape",
    fill: "#CB3837"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "2.77777778 13.8888889 8.33333333 13.8888889 8.33333333 5.55555556 11.1111111 5.55555556 11.1111111 13.8888889 13.8888889 13.8888889 13.8888889 2.77777778 2.77777778 2.77777778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666667,2.77777778 L16.6666667,16.6666667 L22.2222222,16.6666667 L22.2222222,13.8888889 L27.7777778,13.8888889 L27.7777778,2.77777778 L16.6666667,2.77777778 Z M25,11.1111111 L22.2222222,11.1111111 L22.2222222,5.55555556 L25,5.55555556 L25,11.1111111 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "30.5555556 2.77777778 30.5555556 13.8888889 36.1111111 13.8888889 36.1111111 5.55555556 38.8888889 5.55555556 38.8888889 13.8888889 41.6666667 13.8888889 41.6666667 5.55555556 44.4444444 5.55555556 44.4444444 13.8888889 47.2222222 13.8888889 47.2222222 2.77777778"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.3c4e956c8e64ae7604c215b3b65f9e78.svg";
export { ForwardRef as ReactComponent };